import { css } from '@microsoft/fast-element';
import { LinkAdvisorsCellStyles } from '../link-advisors.styles';

export const CompanyRowsStyles = css`
  :host {
    display: table-row;
  }

  .info-tooltip {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 8px;
    border-radius: 4px;
    border: 1px solid #2e3339;
    background-color: #121212;
    box-sizing: border-box;
    line-height: normal;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.25);
    z-index: 999;
    padding: 6px 8px 2px;
    min-width: 200px !important;
  }

  .tooltip-title {
    width: 200px;
    padding: 8px 0px 0px 8px;
    background-color: rgba(255, 255, 255, 0);
    box-sizing: border-box;
    font-family: 'Roboto-Bold', 'Roboto Bold', 'Roboto', sans-serif;
    font-weight: 700;
    color: #879ba6;
    text-align: left;
    line-height: normal;
    font-size: 10px;
  }

  .tooltip-body {
    display: flex;
    flex-direction: column;
    padding: 6px 8px 2px;
    gap: 2px;
  }

  .tooltip-body > div {
    display: flex;
    flex-flow: row nowrap;
    gap: 50px;
    justify-content: space-between;
  }

  .tooltip-username {
    box-sizing: border-box;
    font-family: 'Roboto-Regular', 'Roboto', sans-serif;
    color: #c9c9c9;
    text-align: left;
    line-height: normal;
    font-size: 10px;
  }

  .tooltip-company {
    font-family: 'Roboto-Bold', 'Roboto Bold', 'Roboto', sans-serif;
    font-weight: 700;
    color: #ffffff;
    text-align: right;
    line-height: normal;
    font-size: 10px;
  }

  .info > svg {
    pointer-events: visible;
    cursor: default;
  }

  ${LinkAdvisorsCellStyles}
`;
